import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

// Inner padding wrapper for page content. The viewport-height shell and
// the single scroll container live in AppShell; PageContainer only owns
// horizontal/vertical inset and a max width so wide monitors don't end
// up with an ocean of whitespace.
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full px-16 py-20 laptop:px-24 laptop:py-24',
        className,
      )}
    >
      {children}
    </div>
  );
}
